module.exports = __webpack_public_path__ + "img/1502800211.cad6d17c.jpg";